export function _getLevelFromClass(element) {
  if (element.className === 'primary-link') {
    return 'primary';
  } else if (element.className === 'navSecondaryLink') {
    return 'secondary';
  } else if (element.className === 'navTertiaryLink') {
    return 'tertiary';
  } else if (element.className === 'locked-item' || element.className === 'locked-item-control') {
    return 'locked-item';
  }
  return '';
}